import { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import NawyNowCard from './components/NawyNowCard';
import NawyNowDevelopers from './components/NawyNowDevelopers';
import MobileNawyNow from './MobileNawyNowView';
import NawyNowPage from './NawyNowView';

const NawyNowContainer = (props: any) => {
  const isMobile = useSelector((state: any) => state.app.isMobile);
  const [animate, setAnimate] = useState(false);
  const animateRef = useRef(animate);

  // Keep ref in sync with state
  useEffect(() => {
    animateRef.current = animate;
  }, [animate]);
  // Add refs and state for scroll logic
  const deltaRef = useRef(0);
  const locked = useRef(true);
  const SCROLL_THRESHOLD = 60;

  const developerLogos = props?.nawyNowDevelopers
    ?.slice(0, 6)
    .map((developer: any) => ({
      logo: developer?.logoPath
    }));

  const getSliderChildren = useCallback(() => {
    return props?.nawyNowFeatured
      ? props?.nawyNowFeatured.map((item: any, index: number) => {
          return <NawyNowCard entity={item} key={item.id ?? index} />;
        })
      : [];
  }, [props?.nawyNowFeatured]);

  const getDevelopersSliderChildren = useCallback(() => {
    return props?.nawyNowDevelopers
      ? props?.nawyNowDevelopers?.map((developer: any) => {
          return <NawyNowDevelopers key={developer.id} developer={developer} />;
        })
      : [];
  }, [props?.nawyNowDevelopers]);

  const nawyNowSliderProps = {
    slidesPerView: 'auto' as 'auto',
    spaceBetweenSlides: !isMobile ? 24 : 16,
    slidesPerGroup: 1,
    children: getSliderChildren(),
    width: !isMobile ? '430px' : '340px',
    height: isMobile ? '330px' : 'auto'
  };

  const nawyNowDevelopersSliderProps = {
    slidesPerView: 'auto' as 'auto',
    spaceBetweenSlides: !isMobile ? 32 : 10,
    slidesPerGroup: 5,
    children: getDevelopersSliderChildren(),
    width: !isMobile ? '80px' : '64px',
    height: !isMobile ? '80px' : '64px',
    autoPlay: true
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    const handleWheel = (e: WheelEvent) => {
      let newDelta = deltaRef.current;

      if (e.deltaY > 0 && locked.current) {
        newDelta += Math.abs(e.deltaY);
        deltaRef.current = newDelta;
        if (newDelta >= SCROLL_THRESHOLD) {
          setAnimate(true);
          deltaRef.current = 0;
          e.preventDefault?.();
          setTimeout(() => {
            locked.current = false;
          }, 1000);
          return;
        }
      } else if (e.deltaY < 0 && window.scrollY == 0) {
        locked.current = true;
        setAnimate(false);
        e.preventDefault?.();
        return;
      } else {
        return;
      }
      e.preventDefault?.();
    };

    window.addEventListener('wheel', handleWheel, { passive: false });

    return () => {
      window.removeEventListener('wheel', handleWheel);
    };
  }, []);

  return isMobile ? (
    <MobileNawyNow
      animate={animate}
      {...props}
      sliderProps={nawyNowSliderProps}
      developerLogos={developerLogos}
      developersSliderProps={nawyNowDevelopersSliderProps}
    />
  ) : (
    <NawyNowPage
      animate={animate}
      {...props}
      sliderProps={nawyNowSliderProps}
      developerLogos={developerLogos}
      developersSliderProps={nawyNowDevelopersSliderProps}
    />
  );
};

export default NawyNowContainer;
